import { MarketsSort, SortBy } from "@silo/types";
import { useCallback, useState } from "react";
import { match } from "ts-pattern";

export function useMarketsSortState() {
  const [marketsSort, setMarketsSort] = useState<MarketsSort>(null);

  const sortBy = useCallback<SortBy>(
    (field, direction) => {
      match({ direction, marketsSort })
        .with({ direction: "asc" }, ({ direction }) => {
          setMarketsSort({ field, direction });
        })
        .with({ direction: "desc" }, ({ direction }) => {
          setMarketsSort({ field, direction });
        })
        .with({ marketsSort: { field, direction: "desc" } }, () => {
          setMarketsSort({ field, direction: "asc" });
        })
        .with({ marketsSort: { field, direction: "asc" } }, () => {
          setMarketsSort(null);
        })
        .otherwise(() => {
          setMarketsSort({ field, direction: "desc" });
        });
    },
    [marketsSort]
  );

  const resetSort = useCallback(() => {
    setMarketsSort(null);
  }, []);

  return {
    marketsSort,
    sortBy,
    resetSort,
  };
}
